import { Suspense, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Routes, useNavigate, Route, useLocation } from 'react-router-dom';

import routes from '@/app/routes';
import type { AppDispatch } from '@/app/store';
import AuthRoute from '@/components/AuthRoute';
import Sidebar from '@/components/Sidebar';
import { getAssetHierarchy } from '@/features/assetHierarchy/store/assetHierarchy.thunk';
import BackfillSoftTagPage from '@/pages/backfill-soft-tag';
import { getClassNames } from '@/utils/helpers';
import { MicrofrontendDetector } from '@/utils/MicroFrontendDetector';
import { Spinner } from '@yaradigitallabs/ahua-react';

import BulkImportsHistoryPage from './bulk-imports-history';
import CreateSoftTagsPage from './create-soft-tag';
import EditSoftTagsPage from './edit-soft-tag';
import ListTagsPage from './list-soft-tags';

const Layout = ({ isAuthenticated }: { isAuthenticated: boolean }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();

  const isMicrofrontend = useMemo(() => {
    return MicrofrontendDetector.isMicrofrontend();
  }, []);

  const sidebarRoutes = [
    // {
    //   id: 'list-tags',
    //   text: 'Soft Tags',
    //   icon: "Home",
    //   selected: true,
    //   iconTrailing: 'Home',
    //   url: '/list-tags',
    // }
  ];
  const [collapsed, setCollapsed] = useState(true);
  const [selected, setSelected] = useState('');

  useEffect(() => {
    if (location.pathname !== routes.BULK_IMPORTS_HISTORY) {
      navigate(routes.LIST_TAGS, { replace: true });
    }
    dispatch(getAssetHierarchy());
  }, [dispatch]);

  return (
    <section className={`flex flex-row ${isMicrofrontend ? 'mt-0' : 'mt-14'}`}>
      {!isMicrofrontend && (
        <Sidebar
          routes={sidebarRoutes}
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          selected={selected}
          setSelected={setSelected}
        />
      )}
      <div
        className={getClassNames(
          isAuthenticated
            ? `transition-margin ${
                isMicrofrontend
                  ? 'min-w-[calc(100vw-0px)]'
                  : !collapsed
                    ? 'duration-500 ease-out  min-w-[calc(100vw-192px)]'
                    : 'duration-300 ease-in min-w-[calc(100vw-80px)]'
              }`
            : '',
          `${isMicrofrontend ? 'h-[calc(100vh-0px)] max-h-[calc(100vh-0px)]' : 'h-[calc(100vh-60px)] max-h-[calc(100vh-60px)]'} overflow-auto`
        )}
      >
        <Suspense fallback={<Spinner />}>
          <Routes>
            <Route
              path={routes.LIST_TAGS}
              element={
                <AuthRoute isAuthenticated={isAuthenticated}>
                  <ListTagsPage />
                </AuthRoute>
              }
            />
            <Route
              path={routes.CREATE_SOFT_TAG}
              element={
                <AuthRoute isAuthenticated={isAuthenticated}>
                  <CreateSoftTagsPage />
                </AuthRoute>
              }
            />
            <Route
              path={routes.EDIT_SOFT_TAG}
              element={
                <AuthRoute isAuthenticated={isAuthenticated}>
                  <EditSoftTagsPage />
                </AuthRoute>
              }
            />
            <Route
              path={routes.BACKFILL_SOFT_TAG}
              element={
                <AuthRoute isAuthenticated={isAuthenticated}>
                  <BackfillSoftTagPage />
                </AuthRoute>
              }
            />
            <Route
              path={routes.BULK_IMPORTS_HISTORY}
              element={
                <AuthRoute isAuthenticated={isAuthenticated}>
                  <BulkImportsHistoryPage />
                </AuthRoute>
              }
            />
          </Routes>
        </Suspense>
      </div>
    </section>
  );
};
export default Layout;
